import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bankAccountNumberFormat',
})
export class BankAccountNumberFormatPipe implements PipeTransform {
  transform(value: string): string {
    const regex = /(.{2})(.{4})(.{4})(.{4})(.{4})(.{4})(.{4})(.*)/g;
    return value && value.replace(regex, '$1 $2 $3 $4 $5 $6 $7 $8');
  }
}
